module.exports = __webpack_public_path__ + "media/application/images/icons/items-money-pebble-dark-green-rgb-b32c0d8364b38749dd7495814ae7a152.svg";